/* eslint-disable import/no-extraneous-dependencies */
import React, { CSSProperties } from 'react';
import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputProps,
} from '@chakra-ui/react';
import { UseFormRegister, FieldValues } from 'react-hook-form';
import _ from 'lodash';
import { FieldGroup, fieldPadding } from '../FieldGroup';
import { iconForFieldName } from '../fieldIcons';

interface InputFormProps extends InputProps {
  name: string | undefined | any;
  label: string | undefined;
  iconLeft?: JSX.Element | null;
  iconRight?: JSX.Element;
  labelStyles?: CSSProperties;
  infoButton?: JSX.Element;
  isRequired?: boolean;
  isLoading?: boolean;
  placeholder?: string | undefined;
  register: UseFormRegister<FieldValues>;
  errors: any;
}

export const InputForm = ({
  name,
  label,
  iconLeft,
  iconRight,
  labelStyles,
  infoButton,
  isRequired = false,
  isLoading = false,
  register,
  errors,
  ...rest
}: InputFormProps) => {
  const resolvedIconLeft =
    iconLeft === null ? undefined : iconLeft ?? iconForFieldName(name, rest.type);
  const hasRight = Boolean(iconRight) || isLoading;

  return (
    <FormControl isRequired={isRequired} isInvalid={!!_.get(errors, name)}>
      <Flex align="end">
        <FormLabel style={labelStyles} htmlFor={name}>
          {label}
        </FormLabel>
        {infoButton}
      </Flex>
      <FieldGroup iconLeft={resolvedIconLeft} iconRight={iconRight} isLoading={isLoading}>
        <Input
          id={name}
          {...fieldPadding(Boolean(resolvedIconLeft), hasRight)}
          {...register(name)}
          {...rest}
        />
      </FieldGroup>
      {_.get(errors, name) && <FormErrorMessage>{_.get(errors, name)?.message}</FormErrorMessage>}
    </FormControl>
  );
};
